module.exports = __webpack_public_path__ + "static/media/OM.33bcad92.jpg";